<template>
    <div class="text-center my-12">
      <h2 class="text-3xl font-bold">Explore Cities</h2>
      <p class="text-gray-600">Explore our best deals all over Indonesia</p>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mt-8">
        <div class="relative col-span-2 row-span-2 rounded-lg overflow-hidden group">
          <img src="/assets/images/jakarta.jpg" alt="Jakarta" class="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" />
          <div class="absolute inset-0 bg-black bg-opacity-50 flex flex-col justify-end p-4 transition-opacity duration-300 group-hover:bg-opacity-60">
            <p class="text-white">256 Properties</p>
            <h3 class="text-xl font-bold text-white">Jakarta</h3>
          </div>
        </div>
        <div v-for="city in cities" :key="city.name" class="relative rounded-lg overflow-hidden group">
          <img :src="city.image" alt="City" class="w-full h-48 object-cover transition-transform duration-300 group-hover:scale-105" />
          <div class="absolute inset-0 bg-black bg-opacity-50 flex flex-col justify-end p-4 transition-opacity duration-300 group-hover:bg-opacity-60">
            <p class="text-white">{{ city.properties }} Properties</p>
            <h3 class="text-xl font-bold text-white">{{ city.name }}</h3>
          </div>
        </div>
      </div>
    </div>
  </template>

  <script>
  export default {
    data() {
      return {
        cities: [
          { name: 'Bandung', properties: 256, image: '/assets/images/bandung.jpg' },
          { name: 'Bogor', properties: 256, image: '/assets/images/bogor.jpg' },
          { name: 'Semarang', properties: 256, image: '/assets/images/semarang.jpg' },
          { name: 'Surabaya', properties: 256, image: '/assets/images/surabaya.jpg' },
          { name: 'Bali', properties: 256, image: '/assets/images/bali.jpg' },
        ],
      };
    },
  };
  </script>

  <style scoped>
  /* Add any additional styles here */
  </style>
